/**
 * Copia o title do label/container para os campos internos.
 *
 * O formset recria linhas dinamicamente; manter o title no input melhora o hover
 * quando a tabela fica rolável e o texto do cabeçalho não está visível.
 */
export function syncFormFieldTitles(root = document)
{
	if (!root) return;
	root.querySelectorAll('label[title], td[title], span[title], div[title]').forEach((container) =>
	{
		const title = container.getAttribute('title');
		if (!title) return;
		container.querySelectorAll('input, select, textarea').forEach((field) =>
		{
			if (!field.getAttribute('title'))
				field.setAttribute('title', title);
		});
	});
}

/**
 * Mantém os titles sincronizados após alterações de DOM dentro do formulário.
 */
export function bindFormFieldTitleSync(root = document)
{
	if (!root || root.dataset?.fieldTitleSyncBound === '1') return;
	syncFormFieldTitles(root);
	if (root.dataset)
		root.dataset.fieldTitleSyncBound = '1';
	const observer = new MutationObserver(() => syncFormFieldTitles(root));
	observer.observe(root, { childList: true, subtree: true });
}
